import React from 'react';
import { Patient, ProgramPatients, formatPhone } from '@bforms-web/common';

import { PATIENT_EDIT_ROUTE, PATIENT_REGISTER_ROUTE } from '../../constants';
import Table, { TableProps } from '../Table';
import { KeysLocalStorage } from '../../enums/keys-localstorage';

const columns = [
  {
    key: 'patientEmail',
    label: 'E-mail',
    render: (value: any, patientEmail: ProgramPatients) => {
        return patientEmail.patient?.email ? patientEmail.patient.email : 'N/A';
    }
  },
  {
    key: 'patientName',
    label: 'Nome',
    render: (value: any, patientName: ProgramPatients) => {
      return patientName.patient.name;
    }
  },
  {
    key: 'patientCellPhone',
    label: 'Celular',
    render: (value: any, patientCellPhone: ProgramPatients) => {
      return patientCellPhone.patient?.cellPhone ? formatPhone(patientCellPhone.patient.cellPhone) : 'N/A';
    }
  },
  {
    key: 'programName',
    label: 'Programa',
    render: (value: any, programName: ProgramPatients) => {
      return programName.program.name;
    }
  }
];

export type PatientTableProps = {
  data: ProgramPatients[];
} & Pick<
TableProps,
'count'
| 'onChangePage'
| 'onChangeRows'
| 'onRemove'
| 'onSearch'
| 'page'
| 'rowsPerPage'
>;

function savePatientLocalStorage(patient: ProgramPatients) {
  localStorage.setItem(KeysLocalStorage.DATA_PATIENT, JSON.stringify(patient));
}

export default function PatientTable({ 
  data, 
  ...props 
}: PatientTableProps): JSX.Element {
  return (
    <Table
      columns={columns}
      data={data}
      title={'Pacientes'}
      size="small"
      canAdd
      addRoute={PATIENT_REGISTER_ROUTE}
      canEdit
      editRoute={PATIENT_EDIT_ROUTE}
      editOnClick={savePatientLocalStorage}
      canRemove
      {...props}
    />
  );
}
